import { render, staticRenderFns } from "./HotelHoras.vue?vue&type=template&id=f5278f24"
import script from "./HotelHoras.vue?vue&type=script&lang=js"
export * from "./HotelHoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports